<template>
  <div class="container" :style="{ 'background-image': 'url(' + bgUrl + ')' }">
    <header>
      <div :class="['menu-bar']">
        <a-row justify="space-between">
          <a-col :span="4">
            <div class="logo">
              <router-link to="/"
                ><img src="/img/logo.png" alt=""
              /></router-link>
            </div>
          </a-col>
        </a-row>
      </div>
    </header>
    <div class="article">
      <router-view />
    </div>
    <a-back-top />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
export default {
  name: "LogoLayout",
  components: {
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>

<style lang="less" scoped>
.menu-bar {
  padding: 10px;
  background-color: @primary-color;
  transition: all 0.1s ease;
  height: 70px;
  .logo {
    height: 40px;
    img {
      height: 100%;
    }
  }
}
.container {
  min-height: 100vh;
  // background: linear-gradient(
  //     180deg,
  //     rgb(59, 143, 238) 7%,
  //     rgb(155, 216, 243) 100%
  //   );
  background: #f0f2f5 no-repeat 50%;
  .home {
    width: 1200px;
    margin: auto;
  }
}
</style>